const truthyValues = ["1", "true", "yes", "on"];
const falsyValues = ["0", "false", "no", "off"];

const isTruthyEnv = (value) => {
  if (value === undefined || value === null || value === "") {
    return false;
  }
  const normalized = String(value).trim().toLowerCase();
  if (falsyValues.includes(normalized)) {
    return false;
  }
  return truthyValues.includes(normalized);
};

/** Persist artists/releases/music links/landing pages + tenant overrides in sessionStorage (clears when the tab closes). */
export const isBrowserSessionDemo = () => isTruthyEnv(process.env.REACT_APP_BROWSER_SESSION_DEMO);

export const isDemoMode = () => {
  const value = process.env.REACT_APP_DEMO_MODE;

  if (value === undefined || value === null || value === "") {
    return true;
  }

  const normalized = String(value).trim().toLowerCase();

  if (falsyValues.includes(normalized)) {
    return false;
  }

  return truthyValues.includes(normalized);
};

/** When set (non-empty), demo login can complete 2FA without calling the API if the user enters this exact code. Only use in demo/staging builds. */
export const getConfiguredDemoOtp = () =>
  String(process.env.REACT_APP_DEMO_OTP || "").trim();

export const isDemoOtpBypassEnabled = () =>
  isDemoMode() && getConfiguredDemoOtp().length > 0;

/** Show "Copy mock data" on demo list screens (exports JSON for seed file updates). */
export const isCopyMockDataEnabled = () =>
  isTruthyEnv(process.env.REACT_APP_COPY_MOCK_DATA);

export const isDemoLocked = () => isDemoMode() || isBrowserSessionDemo();

/** reCAPTCHA v3 on login/signup. Off by default; set REACT_APP_RECAPTCHA_ENABLED=true to turn on. */
export const isRecaptchaEnabled = () => {
  const value = process.env.REACT_APP_RECAPTCHA_ENABLED;
  if (value === undefined || value === null || value === "") {
    return false;
  }
  return isTruthyEnv(value);
};

export const DEMO_FEATURE_UNAVAILABLE =
  "This feature is not available in demo";

export const demoCopy = {
  loginTitle: "Log In To Your Demo Account",
  loginIntro: "Preview a fully branded white-label tenant with sample catalog, finance, branding, SLA, and team data.",
  loginSteps: [
    "Login to your demo account.",
    "Explore tenant branding, distribution, reporting, invoices, SLA, and deployment credits.",
    "Use the sample records to evaluate the workflow without changing live data.",
  ],
  sampleDataNotice:
    "The information shown here is sample demo data for preview purposes and does not represent live account activity.",
  twoFactorDemoNotice:
    "Two-factor methods, QR codes, backup codes, and OTP flows shown here are for demo purposes only. They mirror the real product for preview only. These are not connected to live security services, and will not work with real authenticator apps or email delivery.",
};
